import { useTranslation } from 'react-i18next';

import { LabeledValue } from 'core/elements';

import { IQuoteAddressForm } from './types';

interface IProps {
  quoteAddress: IQuoteAddressForm;
}

export const ContactDetails = ({ quoteAddress }: IProps) => {
  const { t } = useTranslation();

  return (
    <>
      <LabeledValue label={t('labelName')} value={quoteAddress.contactName} />
      <LabeledValue label={t('labelPhone')} value={quoteAddress.contactPhone} />
      <LabeledValue label={t('labelEmail')} value={quoteAddress.contactEmail} />
      <LabeledValue label={t('labelCompanyName')} value={quoteAddress.contactCompanyName} />
    </>
  );
};
